
import { Link as ReactRouterLink } from "react-router-dom";

const IS_EXTERNAL_LINK_REGEX = /^(?:[a-z][a-z\d+.-]*:|\/\/)/;

/** Polaris Link adapter — keep `any` to avoid @types/react 18/19 mismatch in this app. */
const Link: any = ({
  children,
  url = "",
  external,
  ref,
  ...rest
}: {
  children?: any;
  url?: string;
  external?: boolean;
  ref?: any;
  [key: string]: any;
}) => {
  // react-router only supports links to pages it can handle itself. It does not
  // support arbirary links, so anything that is not a path-based link should
  // use a reglar old `a` tag
  if (external || IS_EXTERNAL_LINK_REGEX.test(url)) {
    rest.target = "_blank";
    rest.rel = "noopener noreferrer";
    return (
      <a href={url} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <ReactRouterLink to={url} {...rest}>
      {children}
    </ReactRouterLink>
  );
};
export default Link;
